import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TrendingUpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"trending_up"}/>
}
